export const extraCostOptions = [
    // =========================
    // A) Border & Customs
    // =========================
    {
        group: "Border & Customs",
        label: "Export customs clearance (Gümrükleme hizmet bedeli)",
    },
    {
        group: "Border & Customs",
        label: "Import customs clearance (İthalat gümrükleme)",
    },
    {
        group: "Border & Customs",
        label: "Customs documentation & handling fee (Evrak / işlem bedeli)",
    },
    {
        group: "Border & Customs",
        label: "T1 / Transit document cost (T1 / Transit belge masrafı)",
    },
    {
        group: "Border & Customs",
        label: "T2 / Transit document cost (T2 belge masrafı)",
    },
    {
        group: "Border & Customs",
        label: "Guarantee / bond / customs deposit (Teminat / depozito)",
    },
    {
        group: "Border & Customs",
        label: "Transit guarantee fee (Transit teminat ücreti)",
    },
    {
        group: "Border & Customs",
        label: "Customs inspection / red line handling (Muayene / kırmızı hat)",
    },
    {
        group: "Border & Customs",
        label: "Physical inspection fee (Fiziki muayene)",
    },
    {
        group: "Border & Customs",
        label: "X-ray / scanning fee (X-Ray / tarama)",
    },
    {
        group: "Border & Customs",
        label: "Weighbridge fee (Kantar)",
    },
    {
        group: "Border & Customs",
        label: "Brokerage extra services (Mesai dışı / düzeltme / ek beyan)",
    },
    {
        group: "Border & Customs",
        label: "Transit customs escort (Gümrük refakat hizmeti)",
    },
    {
        group: "Border & Customs",
        label: "ATA Carnet handling",
    },
    {
        group: "Border & Customs",
        label: "EUR1 / ATR / Certificate issuance",
    },

    // =========================
    // B) Loading & Waiting
    // =========================
    {
        group: "Loading & Waiting",
        label: "Loading charges (Yükleme)",
    },
    {
        group: "Loading & Waiting",
        label: "Unloading charges (Boşaltma)",
    },
    {
        group: "Loading & Waiting",
        label: "Forklift service",
    },
    {
        group: "Loading & Waiting",
        label: "Crane service",
    },
    {
        group: "Loading & Waiting",
        label: "Manual labor",
    },
    {
        group: "Loading & Waiting",
        label: "Tail-lift service",
    },
    {
        group: "Loading & Waiting",
        label: "Side loading",
    },
    {
        group: "Loading & Waiting",
        label: "Top loading",
    },
    {
        group: "Loading & Waiting",
        label: "Waiting time (Loading)",
    },
    {
        group: "Loading & Waiting",
        label: "Waiting time (Unloading)",
    },
    {
        group: "Loading & Waiting",
        label: "Truck detention",
    },
    {
        group: "Loading & Waiting",
        label: "Driver standby",
    },
    {
        group: "Loading & Waiting",
        label: "Appointment / time-slot booking",
    },
    {
        group: "Loading & Waiting",
        label: "Warehouse handling",
    },
    {
        group: "Loading & Waiting",
        label: "Cross-docking",
    },
    {
        group: "Loading & Waiting",
        label: "Yard / terminal entrance fee",
    },
    {
        group: "Loading & Waiting",
        label: "Failed loading",
    },
    {
        group: "Loading & Waiting",
        label: "Failed delivery",
    },
    {
        group: "Loading & Waiting",
        label: "Truck return (Boş dönüş)",
    },
    {
        group: "Loading & Waiting",
        label: "Extra pickup point",
    },
    {
        group: "Loading & Waiting",
        label: "Extra delivery point",
    },

    // =========================
    // C) Route & Regulatory
    // =========================
    {
        group: "Route & Regulatory",
        label: "Motorway toll",
    },
    {
        group: "Route & Regulatory",
        label: "Bridge toll",
    },
    {
        group: "Route & Regulatory",
        label: "Tunnel fee",
    },
    {
        group: "Route & Regulatory",
        label: "Ro-Ro charges",
    },
    {
        group: "Route & Regulatory",
        label: "Ferry charges",
    },
    {
        group: "Route & Regulatory",
        label: "Permit fee",
    },
    {
        group: "Route & Regulatory",
        label: "Transit permit",
    },
    {
        group: "Route & Regulatory",
        label: "Special route permit",
    },
    {
        group: "Route & Regulatory",
        label: "Oversize permit",
    },
    {
        group: "Route & Regulatory",
        label: "ADR permit",
    },
    {
        group: "Route & Regulatory",
        label: "Weekend driving restriction surcharge",
    },
    {
        group: "Route & Regulatory",
        label: "Holiday driving restriction surcharge",
    },
    {
        group: "Route & Regulatory",
        label: "Police escort",
    },
    {
        group: "Route & Regulatory",
        label: "Pilot vehicle",
    },
    {
        group: "Route & Regulatory",
        label: "Low emission zone (LEZ)",
    },
    {
        group: "Route & Regulatory",
        label: "City congestion charge",
    },
    {
        group: "Route & Regulatory",
        label: "Environmental tax",
    },

    // =========================
    // D) Equipment & Cargo
    // =========================
    {
        group: "Equipment & Cargo",
        label: "Pallet exchange",
    },
    {
        group: "Equipment & Cargo",
        label: "Pallet purchase",
    },
    {
        group: "Equipment & Cargo",
        label: "Lashing",
    },
    {
        group: "Equipment & Cargo",
        label: "Cargo securing",
    },
    {
        group: "Equipment & Cargo",
        label: "Dunnage",
    },
    {
        group: "Equipment & Cargo",
        label: "Blocking & bracing",
    },
    {
        group: "Equipment & Cargo",
        label: "Tarpaulin",
    },
    {
        group: "Equipment & Cargo",
        label: "Straps",
    },
    {
        group: "Equipment & Cargo",
        label: "Corner protectors",
    },
    {
        group: "Equipment & Cargo",
        label: "Shrink wrapping",
    },
    {
        group: "Equipment & Cargo",
        label: "Additional packaging",
    },
    {
        group: "Equipment & Cargo",
        label: "Temperature logger",
    },
    {
        group: "Equipment & Cargo",
        label: "Reefer monitoring",
    },
    {
        group: "Equipment & Cargo",
        label: "ADR equipment",
    },
    {
        group: "Equipment & Cargo",
        label: "Cleaning of trailer",
    },
    {
        group: "Equipment & Cargo",
        label: "Trailer washing",
    },
    {
        group: "Equipment & Cargo",
        label: "Trailer disinfection",
    },

    // =========================
    // E) Risk & Financial
    // =========================
    {
        group: "Risk & Financial",
        label: "Cargo insurance (CMR)",
    },
    {
        group: "Risk & Financial",
        label: "All Risk insurance",
    },
    {
        group: "Risk & Financial",
        label: "War risk surcharge",
    },
    {
        group: "Risk & Financial",
        label: "High-risk area surcharge",
    },
    {
        group: "Risk & Financial",
        label: "Border queue surcharge",
    },
    {
        group: "Risk & Financial",
        label: "Storage",
    },
    {
        group: "Risk & Financial",
        label: "Warehouse rent",
    },
    {
        group: "Risk & Financial",
        label: "Cross-dock storage",
    },
    {
        group: "Risk & Financial",
        label: "Address change",
    },
    {
        group: "Risk & Financial",
        label: "Re-delivery",
    },
    {
        group: "Risk & Financial",
        label: "Delivery attempt fee",
    },
    {
        group: "Risk & Financial",
        label: "Bank charges",
    },
    {
        group: "Risk & Financial",
        label: "Payment processing fee",
    },
    {
        group: "Risk & Financial",
        label: "Currency adjustment",
    },
    {
        group: "Risk & Financial",
        label: "Fuel surcharge (BAF / FSC)",
    },
    {
        group: "Risk & Financial",
        label: "Emergency surcharge",
    },
    {
        group: "Risk & Financial",
        label: "Peak season surcharge",
    },

    // =========================
    // F) Driver Related
    // =========================
    {
        group: "Driver",
        label: "Driver accommodation",
    },
    {
        group: "Driver",
        label: "Driver meal allowance",
    },
    {
        group: "Driver",
        label: "Second driver requirement",
    },
    {
        group: "Driver",
        label: "Driver visa expenses",
    },
    {
        group: "Driver",
        label: "PCR / health certificate",
    },

    // =========================
    // G) OOG / Heavy Cargo
    // =========================
    {
        group: "Project & OOG",
        label: "Overweight surcharge",
    },
    {
        group: "Project & OOG",
        label: "Oversize surcharge",
    },
    {
        group: "Project & OOG",
        label: "Route survey",
    },
    {
        group: "Project & OOG",
        label: "Engineering survey",
    },
    {
        group: "Project & OOG",
        label: "Escort vehicle",
    },
    {
        group: "Project & OOG",
        label: "Temporary road closure",
    },
    {
        group: "Project & OOG",
        label: "Utility line lifting",
    },
    {
        group: "Project & OOG",
        label: "Heavy lift crane",
    },

    // =========================
    // H) Miscellaneous
    // =========================
    {
        group: "Miscellaneous",
        label: "Document courier",
    },
    {
        group: "Miscellaneous",
        label: "Courier expenses",
    },
    {
        group: "Miscellaneous",
        label: "Administrative fee",
    },
    {
        group: "Miscellaneous",
        label: "Communication expenses",
    },
    {
        group: "Miscellaneous",
        label: "Unexpected operational expenses",
    },
    {
        group: "Miscellaneous",
        label: "Other",
    },
];